(function () {
    'use strict';

    angular
        .module('app')
        .directive('printPage', printPage);

    printPage.$inject = ['$window'];

    function printPage($window) {
        var printSection = document.getElementById('printSection');

        // if there is no printing section, create one
        if (!printSection) {
            printSection = document.createElement('div');
            printSection.id = 'printSection';
            document.body.appendChild(printSection);
        }

        return {
            link: link,
            restrict: 'A'
        };

        function link(scope, element, attrs) {
            element.on('click', function () {
                var elemToPrint = document.getElementById(attrs.printElementId);
                if (elemToPrint) {
                    printSection.innerHTML = '';
                    // clones the element you want to print
                    var domClone = elemToPrint.cloneNode(true);
                    printSection.appendChild(domClone);
                    $window.print();
                }
            });

            $window.onafterprint = function () {
                // clean the print section before adding new content
                printSection.innerHTML = '';
            };
        }
    }

})();
